import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { IconeQualidadeComponent } from '../icone-qualidade/icone-qualidade.component';
import { IconeMoedasComponent } from '../icone-moedas/icone-moedas.component';
import { IconeFinanceiroComponent } from '../icone-financeiro/icone-financeiro.component';
import { NgClass } from '@angular/common';
import { IconeAtivo } from '../../layouts/layout-editor/layout-editor-content.service';
import { IconeAndarilhoComponent } from '../icone-andarilho/icone-andarilho.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-etapas-de-edicao',
  standalone: true,
  imports: [
    IconeQualidadeComponent,
    IconeMoedasComponent,
    IconeFinanceiroComponent,
    NgClass,
    IconeAndarilhoComponent,
    RouterLink,
  ],
  templateUrl: './etapas-de-edicao.component.html',
  styleUrl: './etapas-de-edicao.component.scss',
})
export class EtapasDeEdicaoComponent implements OnChanges, OnInit {
  @Input() iconeQualidadePreenchido: boolean = false;
  @Input() iconeQualidadeBloqueado: boolean = false;
  @Input() iconeQualidadeSubtituloBold: boolean | undefined;

  @Input() iconeMoedasPreenchido: boolean = false;
  @Input() iconeMoedasBloqueado: boolean = false;
  @Input() iconesMoedasSubtituloBold: boolean | undefined;

  @Input() iconeFinanceiroPreenchido: boolean = false;
  @Input() iconeFinanceiroBloqueado: boolean = false;
  @Input() iconeFinanceiroSubtituloBold: boolean | undefined;

  @Input() iconeAndarilhoPreenchido: boolean = false;
  @Input() iconeAndarilhoBloqueado: boolean = false;
  @Input() iconeAndarilhoSubtituloBold: boolean | undefined;

  @Input() novoResultado = '';
  @Input() caminhoAtual = '';

  @Output() botaoClicado = new EventEmitter<IconeAtivo>();

  iconeAtivo = IconeAtivo;

  ngOnInit(): void {
    // caminhoAtual agora é recebido via @Input do componente pai
  }

  ngOnChanges(): void {
    if (this.iconeQualidadePreenchido) {
      this.iconeQualidadeSubtituloBold = true;
    }

    if (this.iconeMoedasPreenchido) {
      this.iconesMoedasSubtituloBold = true;
    }

    if (this.iconeFinanceiroPreenchido) {
      this.iconeFinanceiroSubtituloBold = true;
    }

    if (this.iconeAndarilhoPreenchido) {
      this.iconeAndarilhoSubtituloBold = true;
    }
  }

  alternarIconePreenchido(icone: IconeAtivo): void {
    if (icone === IconeAtivo.QUALIDADE) {
      this.iconeQualidadePreenchido = !this.iconeQualidadePreenchido;
      return;
    }

    if (icone === IconeAtivo.MOEDAS) {
      this.iconeMoedasPreenchido = !this.iconeMoedasPreenchido;
      return;
    }

    if (icone === IconeAtivo.FINANCEIRO) {
      this.iconeFinanceiroPreenchido = !this.iconeFinanceiroPreenchido;
    }

    if (icone === IconeAtivo.ANDARILHO) {
      this.iconeAndarilhoPreenchido = !this.iconeAndarilhoPreenchido;
    }
  }

  iconeClicado(icone: IconeAtivo): void {
    this.botaoClicado.emit(icone);
  }
}
